import React, { Component } from 'react';
import cx from 'classnames';
import debounce from 'lodash.debounce';

import DefaultInput from 'components/common/Input';
import s from './style';

class Input extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: props.defaultValue || ''
    };

    this.setSearchValue = debounce(this.setSearchValue, 500);
  }

  componentDidMount() {
    this.inputEl.focus();
  }

  handleInputChange = ({ target: { value } }) => {
    this.setState({ searchValue: value });
    this.setSearchValue(value);
  };

  setSearchValue = this.props.setSearchValue

  render() {
    const { className, placeholder, autofocus } = this.props;
    const classes = cx(s.root, className);

    return (
      <div className={classes}>
        <div className={s.Hide1180}>
          <DefaultInput
            onChange={this.handleInputChange}
            placeholder={placeholder[0]}
            defaultValue={this.state.searchValue}
            getRef={inputEl => { this.inputEl = inputEl; }}
            autofocus={autofocus}
          />
        </div>
        <div className={s.Show1180}>
          <DefaultInput
            onChange={this.handleInputChange}
            placeholder={placeholder[1]}
            defaultValue={this.state.searchValue}
            getRef={inputEl => { this.inputEl = inputEl; }}
            autofocus={autofocus}
          />
        </div>
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Input/Input.js